export enum APIResponseStatus {
  Error = 'error',
  Success = 'success',
  Queued = 'queued'
}
